'use client';
import { createContext, useContext } from 'react';

export const DEFAULT_COMP_CONFIG = {
  colorPrimary: '#2563eb',
  colorSecondary: '#1e40af',
  colorBg: '#f6f7f9',
  colorText: '#2e2e2e',
  colorForeground: '#ffffff',
  showTitle: true,
};

const CompConfigContext = createContext({ ...DEFAULT_COMP_CONFIG, hasDataConfig: false });

export const CompConfigProvider = ({ config, hasDataConfig = false, children }) => {
  const merged = { ...DEFAULT_COMP_CONFIG, ...config, hasDataConfig };
  return (
    <CompConfigContext.Provider value={merged}>
      {children}
    </CompConfigContext.Provider>
  );
};

export const useCompConfig = () => useContext(CompConfigContext);
